{
    document.addEventListener("DOMContentLoaded", function() {
        var wrappers = document.querySelectorAll('.js-attentive-form-wrapper');

        function revealWrapper(wrapper) {
            wrapper.classList.remove('is-loading');
            wrapper.classList.add('is-ready');
        }

        function showForm(wrapper, iframe, src) {
            iframe.addEventListener('load', function() {
                revealWrapper(wrapper);
            }, { once: true });

            iframe.src = src;

            setTimeout(function() {
                if (wrapper.classList.contains('is-loading')) {
                    revealWrapper(wrapper);
                }
            }, 5000);
        }

        function applyAttentiveForm(userLocation) {
            var isUS = userLocation === 'US';

            wrappers.forEach(function(wrapper) {
                var iframe = wrapper.querySelector('.js-attentive-iframe');
                var internationalText = wrapper.querySelector('.js-international-text');
                var formSrc = wrapper.dataset.formSrc;
                var internationalSrc = wrapper.dataset.internationalSrc;

                if (isUS) {
                    if (internationalText) internationalText.remove();
                    if (iframe && formSrc) {
                        showForm(wrapper, iframe, formSrc);
                    } else {
                        revealWrapper(wrapper);
                    }
                    return;
                }

                if (internationalSrc && iframe) {
                    if (internationalText) internationalText.remove();
                    wrapper.classList.add('is-international');
                    iframe.setAttribute('scrolling', 'no');
                    iframe.style.overflow = 'hidden';

                    showForm(wrapper, iframe, internationalSrc);
                    return;
                }

                if (iframe) iframe.remove();
                revealWrapper(wrapper);
            });
        }

        fetch('https://get.geojs.io/v1/ip/country')
            .then(function(response) { return response.text(); })
            .then(function(countryCode) {
                applyAttentiveForm(countryCode.trim());
            })
            .catch(function(error) {
                console.error('Error fetching country code:', error);
                applyAttentiveForm('US');
            });
    });
}
